var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"quemjapassouaqui"},[_c('Container',[_c('div',{staticClass:"quemjapassouaqui__title"},[_c('h1',[_vm._v("Algumas marcas que atendemos nestes 15 anos.")])])]),_c('div',{staticClass:"quemjapassouaqui__content"},[_c('WorkCategories')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }